<script>
import { mapActions } from "vuex";
import { required, requiredIf, minLength, maxLength, url } from "vuelidate/lib/validators"; // for validators
import {swal} from '../../../helpers/handle_error.js';
import AlertError from '@/components/alert_error'
import Video from '../../../model/video.js';

export default {
  components: { AlertError },
  data() {
    return {
      //Page errors.
      errors: [],
      
      video: new Video,
      submitadd: false,
      loadingButton: false,
    };
  },
  validations: {
    video: {
      title_ar: {required: requiredIf(function (){ return this.checkLocale('ar'); }), minLength: minLength(2), maxLength: maxLength(300) },
      title_en: {required: requiredIf(function (){ return this.checkLocale('en'); }), minLength: minLength(2), maxLength: maxLength(300) },
      title_fa: {required: requiredIf(function (){ return this.checkLocale('fa'); }), minLength: minLength(2), maxLength: maxLength(300) },
      locales: {required},
      video_url: {required, url, maxLength: maxLength(500) },
    },
  },
  methods: {
    ...mapActions("video", ['add']),
    handleError(error){
      alert(error)
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    resetForm(){
      this.submitadd = false
      this.loadingButton = false
      this.errors = []
      this.video.reset()
    },
    checkLocale(locale){
      return this.video.locales.includes(locale);
    },
    checkValidate(){
      return !this.$v.video.locales.$error &&
        (!this.checkLocale('ar') || !this.$v.video.title_ar.$error) && 
        (!this.checkLocale('en') || !this.$v.video.title_en.$error) && 
        (!this.checkLocale('fa') || !this.$v.video.title_fa.$error) &&
        !this.$v.video.video_url.$error
    },
    formAddVideo(published = false) {
      this.submitadd = true;
      this.$v.$touch();
      if(!this.checkValidate()) return;

      // to form submit after this
      this.loadingButton = true
      this.errors = [];
      
      this.video.published = published

      this.add(this.video.toFormData())
      .then((response)=>{
        swal.success(response.data.message)
        this.resetForm()
      })
      .catch((error)=>{
        this.handleError(error)
        this.loadingButton = false
      })
    },
    unitTest(){
      this.video.locales = ['ar', 'en', 'fa']
      this.video.video_url = 'https://www.youtube.com/watch?v=3bUodTUDvTY&list=PLDoPjvoNmBAzH72MTPuAAaYfReraNlQgM&index=8'
      this.video.title_ar = 'video test title ar'
      this.video.title_en = 'video test title en'
      this.video.title_fa = 'video test title fa'
      this.video.description_ar = '<h2>video Test Content ar</h2>'
      this.video.description_en = '<h2>video Test Content en</h2>'
      this.video.description_fa = '<h2>video Test Content fa</h2>'
    },
  },
  created(){
    if(process.env.NODE_ENV == "development") {
      this.unitTest()
    }
  },
};
</script>


<template>

  <b-form ref="form">

    <AlertError :errors="errors"></AlertError>

    <div class="row mt-3">

      <b-form-group class="col-md-12 mb-3" label="لغة الفيديو :">
        <b-form-checkbox class="dis-inline" v-model="video.locales" value="ar" plain>عربي</b-form-checkbox>
        <b-form-checkbox class="dis-inline" v-model="video.locales" value="en" plain>انكليزي</b-form-checkbox>
        <!-- <b-form-checkbox class="dis-inline" v-model="video.locales" value="fa" plain>فارسي</b-form-checkbox> -->
         <div v-if="submitadd && $v.video.locales.$error" class="invalid-check">
          <span v-if="!$v.video.locales.required"> يجب اختيار لغة واحدة على الاقل </span>
        </div>
      </b-form-group>

      <b-form-group class="col-md-12 mb-3" label="رابط الفيديو : " label-for="video_url" >
        <b-form-input id="video_url" v-model="video.video_url" :class="{ 'is-invalid': submitadd && $v.video.video_url.$error }" placeholder="ادخل رابط الفيديو" type="url" ></b-form-input>
        <div v-if="submitadd && $v.video.video_url.$error" class="invalid-feedback">
          <span v-if="!$v.video.video_url.required"> هذا الحقل الزامي </span>
          <span v-if="!$v.video.video_url.url"> يجب أن تكون هذه القيمة عنوان url صالحًا. </span>
          <span v-if="!$v.video.video_url.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 500 حرف على الاكثر . </span>
        </div>
      </b-form-group>

      <b-form-group v-if="checkLocale('ar')" class="col-md-12 mb-3 class_ar" label="عنوان الفيديو : ( عربي )" label-for="title_ar" >
        <b-form-input id="title_ar" v-model.trim="video.title_ar" :class="{ 'is-invalid': submitadd && $v.video.title_ar.$error }" placeholder="ادخل عنوان الفيديو" type="text" ></b-form-input>
        <div v-if="submitadd && $v.video.title_ar.$error" class="invalid-feedback">
          <span v-if="!$v.video.title_ar.required"> هذا الحقل الزامي </span>
          <span v-if="!$v.video.title_ar.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
          <span v-if="!$v.video.title_ar.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
        </div>
      </b-form-group>

      <b-form-group v-if="checkLocale('ar')" class="col-md-12 mb-3 class_ar" label="وصف الفيديو : ( عربي )" label-for="description_ar">
        <textarea id="description_ar" v-model="video.description_ar" class="form-control" rows="5" ></textarea>
      </b-form-group>

      <b-form-group v-if="checkLocale('en')" class="col-md-12 mb-3 class_en" label="عنوان الفيديو : ( انجليزي )" label-for="title_en" >
        <b-form-input id="title_en" v-model.trim="video.title_en" :class="{ 'is-invalid': submitadd && $v.video.title_en.$error }" placeholder="ادخل عنوان الفيديو" type="text" ></b-form-input>
        <div v-if="submitadd && $v.video.title_en.$error" class="invalid-feedback">
          <span v-if="!$v.video.title_en.required"> هذا الحقل الزامي </span>
          <span v-if="!$v.video.title_en.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
          <span v-if="!$v.video.title_en.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
        </div>
      </b-form-group>

      <b-form-group v-if="checkLocale('en')" class="col-md-12 mb-3 class_en" label="وصف الفيديو : ( انجليزي )" label-for="description_en" >
        <textarea id="description_en" v-model="video.description_en" class="form-control" rows="5" ></textarea>
      </b-form-group>

      <b-form-group v-if="checkLocale('fa')" class="col-md-12 mb-3 class_fa" label="عنوان الفيديو : ( فارسي )" label-for="title-fa" >
        <b-form-input id="title-fa" v-model.trim="video.title_fa" :class="{ 'is-invalid': submitadd && $v.video.title_fa.$error }" placeholder="ادخل عنوان الفيديو" type="text" ></b-form-input>
        <div v-if="submitadd && $v.video.title_fa.$error" class="invalid-feedback">
          <span v-if="!$v.video.title_fa.required"> هذا الحقل الزامي </span>
          <span v-if="!$v.video.title_fa.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
          <span v-if="!$v.video.title_fa.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
        </div>
      </b-form-group>

      <b-form-group v-if="checkLocale('fa')" class="col-md-12 mb-3 class_fa" label="وصف الفيديو : ( فارسي )" label-for="description_fa" >
        <textarea id="description_fa" v-model="video.description_fa" class="form-control" rows="5" ></textarea>
      </b-form-group>

    </div>

    <div class="mt-3">
      <hr>
      <b-button :disabled="loadingButton" @click="formAddVideo(false)" variant="primary" type="button" class="me-2"> 
        <b-spinner v-if="loadingButton && !video.published" small></b-spinner>
        <span v-else><i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ</span>
      </b-button>

       <b-button :disabled="loadingButton" @click="formAddVideo(true)" variant="success" type="button"> 
        <b-spinner v-if="loadingButton && video.published" small></b-spinner>
        <span v-else><i class="bx bx-paper-plane font-size-16 align-middle me-2"></i>نشر</span>
      </b-button>
    </div>

  </b-form>

</template>